<template>
  <div>
    <!-- <div class="login-con"> -->
      <Card icon="log-in" title="欢迎注册" :bordered="false"  style="width:1100px;margin-left:auto;margin-right:auto">
        <div class="form-con">
          <register-form @on-success-valid="handleSubmit"></register-form>
        </div>
      </Card>
    </div>
  <!-- </div> -->
</template>
<script>
import RegisterForm from "_c/register-form";
export default {
  components: {
    RegisterForm
  },
  methods: {
    handleSubmit(form) {
      this.$axios.post("/app/auth/register", form)
        .then(res => {
          if (res.code == 1) {
            this.formLoading = false;
            this.$Message.success('注册成功');
            this.$router.replace({ name: "Login" });
          } else {
            this.formLoading = false;
            this.$Message.error(res.msg);
          }
        });
    }
  }
};
</script>

<style lang="less">
</style>
